export interface IAdoptEaseLocalizedText {
  enUS?: string;
  enCA?: string;
  frCA?: string;
}

export type AdoptEaseCampaignActionType = 'WORKFLOW' | 'DEEP_LINK' | 'CUSTOM_URL';

export interface IAdoptEaseCampaignTargeting {
  enterpriseIds: string[];
  storeIds: string[];
  cNumbers: string[];
  roles: string[];
  permissions: string[];
}

export interface IAdoptEaseCampaign {
  id: string;
  appId: string;
  isActive: boolean;
  title: IAdoptEaseLocalizedText;
  description: IAdoptEaseLocalizedText;
  ctaText?: IAdoptEaseLocalizedText;
  openButtonText?: IAdoptEaseLocalizedText;
  startDate: string;
  endDate: string;
  targeting: IAdoptEaseCampaignTargeting;
  ctaAction: {
    type: AdoptEaseCampaignActionType;
    url: string;
  };
  cdkuUrl?: string;
  surveyUrl?: string;
  createdBy?: string;
  createdAt?: string;
  updatedBy?: string;
  updatedAt?: string;
}

export enum AdoptEaseCampaignAction {
  OPEN_MODAL = 'Open Modal',
  DISMISS = 'Dismiss',
  OPEN_WORKFLOW = 'Open Workflow',
  TAKE_TRAINING = 'Take Training',
}
